import React from "react";

const PricingCard = (props) => {

  const { price, products, isPaid = false } = props;

  return (
    <div className="col-md-2">
      <div className={`card mb-4 card-shadow`}>
        <div className="card-body">
          <div className="pricing-price">
            <h1 className={`card-title pricing-card-title`}>{price} {isPaid && <small className="text-muted">/ mo</small>}</h1>
            <h4 className={`my-0 price`}>{products} Products</h4>
          </div>

          <div className="priceline"></div>

          <ul className="list-unstyled mt-3 mb-4 pricing">
            {isPaid && <li>14 Day Free Trial</li>}
            <li>4x Daily feed sync</li>
            <li>Multi-Platform Support</li>
            <li>Includes sale pricing</li>
            <li>Includes variants</li>
            <li>AI Google Category mapping</li>
            <li>AI Feed Health Checks</li>
            <li>Feed column mapping</li>
            <li>Smart feed rules</li>
            <li>UTM parameter tracking</li>
            <li>Easy install</li>
            {isPaid && <li>Dedicated Support</li>}
          </ul>
        </div>
      </div>
    </div>
  )

}

export default PricingCard;